// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../index';

import { gql } from 'graphql-tag';
import { BlockFragmentDoc } from '../../../components/cms/CmsBlock.fragment.generated';
import { Banner1FragmentDoc } from '../fragments/banner1.fragment.generated';
import { Banner2FragmentDoc } from '../fragments/banner2.fragment.generated';
import { MetaFragmentDoc } from '../fragments/meta.fragment.generated';
export const ProductPageListingFragmentDoc = gql`
    fragment productPageListing on ProductPageListing {
  id
  beforeFilters {
    ...block
  }
  afterGrid {
    ...block
  }
  banner1 {
    ...banner1
  }
  banner2 {
    ...banner2
  }
  meta {
    ...meta
  }
}
    ${BlockFragmentDoc}
${Banner1FragmentDoc}
${Banner2FragmentDoc}
${MetaFragmentDoc}`;